import React from "react";
import styles from "./Content.module.css";
import type { ContentPageSlideProps } from "../../utils/contentful-helpers";

type ContentProps = Pick<
  ContentPageSlideProps,
  "title" | "displayName" | "description" | "images"
>;

const Content = ({ title, displayName, description, images }: ContentProps) => {
  const renderDescription = () => {
    if (typeof description === "string") {
      return <p>{description}</p>;
    }

    if (description.content?.length) {
      return description.content.map((item, index) => (
        <p key={index}>
          {item.content?.[0]?.value ?? "No description available"}
        </p>
      ));
    }

    return <p>No description available</p>;
  };

  return (
    <div className={styles.content}>
      <div className={styles.text_content}>
        <h2 className={styles.content_title}>{title}</h2>
        <div className={styles.content_description}>{renderDescription()}</div>

        {displayName && (
          <p className={styles.content_display_name}>{displayName}</p>
        )}
      </div>

      {images.length > 0 && (
        <img
          src={images[0]?.fields?.file?.url ?? ""}
          alt={title || "Content image"}
          className={styles.content_image}
        />
      )}
    </div>
  );
};

export default Content;
